import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Avatar, Button, Modal, Tooltip } from 'antd';
import { styleVariables } from '@lib/common';
import styled from '@xstyled/styled-components';
import { createGlobalStyle } from 'styled-components';
import { useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ShareAssignmentModalStyles = createGlobalStyle([".share-assignment-modal.ant-modal-confirm{max-width:calc(100vw - 32px);}.share-assignment-modal .ant-modal-content{overflow:hidden;border:1px solid ", ";border-radius:20px;box-shadow:0 20px 48px rgba(15,23,42,0.2);}.share-assignment-modal .ant-modal-body{padding:0;}.share-assignment-modal .ant-modal-confirm-body-wrapper,.share-assignment-modal .ant-modal-confirm-body,.share-assignment-modal .ant-modal-confirm-content{width:100%;}.share-assignment-modal .ant-modal-confirm-body > .anticon{display:none;}.share-assignment-modal .ant-modal-confirm-content{max-width:none;margin:0 !important;}.share-assignment-modal .ant-modal-confirm-btns{display:none;}"], styleVariables.colors.gray8);
var StyledModalContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 32px;\n\n  @media (max-width: 600px) {\n    padding: 20px;\n  }\n"])));
var StyledHeader = styled.header(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n"])));
var StyledSuccessIcon = styled(Avatar)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n"])));
var StyledTitle = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  min-width: 0;\n  margin: 0;\n  color: ", ";\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n"])), styleVariables.colors.gray12);
var StyledFooter = styled.footer(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n"])));
var StyledConfirmButton = styled(Button)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: 40px;\n  border-radius: 8px;\n"])));
var StyledShareContent = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"])));
var StyledSection = styled.section(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([""])));
var StyledInformation = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  color: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n"])), styleVariables.colors.gray12);
var StyledCopyField = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  height: 48px;\n  overflow: hidden;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  &:focus-within {\n    border-color: ", ";\n    box-shadow: 0 0 0 2px rgba(25, 90, 255, 0.12);\n  }\n"])), styleVariables.colors.gray1, styleVariables.colors.gray8, styleVariables.colors.colorPrimaryBase);
var StyledInput = styled.input(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  padding: 0 16px;\n  font: inherit;\n  color: ", ";\n  background: ", ";\n  border: 0;\n  border-radius: 0;\n  outline: none;\n  box-shadow: none !important;\n"])), styleVariables.colors.gray13, styleVariables.colors.gray1);
var StyledCopyButton = styled(Button)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 56px;\n  min-width: 56px;\n  height: 100%;\n  padding: 0;\n  color: ", ";\n  background: ", ";\n  border: 0;\n  border-left: 1px solid ", ";\n  border-radius: 0;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n"])), styleVariables.colors.colorPrimaryBase, styleVariables.colors.gray1, styleVariables.colors.gray8, styleVariables.colors.blue4, styleVariables.colors.blue1, styleVariables.colors.gray8);
var StyledQrBlock = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n"])));
var StyledQrHint = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  max-width: 420px;\n  color: ", ";\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n"])), styleVariables.colors.gray11);
var StyledQrImage = styled.img(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  width: 200px;\n  height: 200px;\n  padding: 8px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n"])), styleVariables.colors.gray1, styleVariables.colors.gray8);

var CopyField = function CopyField(_ref) {
  var text = _ref.text,
      fieldLabel = _ref.fieldLabel,
      copyLabel = _ref.copyLabel,
      copiedLabel = _ref.copiedLabel;

  var _useState = useState(false),
      isCopied = _useState[0],
      setIsCopied = _useState[1];

  var copiedTimerRef = useRef();
  var handleCopy = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return navigator.clipboard.writeText(text);

          case 3:
            setIsCopied(true);
            if (copiedTimerRef.current) clearTimeout(copiedTimerRef.current);
            copiedTimerRef.current = setTimeout(function () {
              return setIsCopied(false);
            }, 2000);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            setIsCopied(false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  })), [text]);
  useEffect(function () {
    return function () {
      if (copiedTimerRef.current) clearTimeout(copiedTimerRef.current);
    };
  }, []);
  return /*#__PURE__*/_jsxs(StyledCopyField, {
    children: [/*#__PURE__*/_jsx(StyledInput, {
      value: text,
      readOnly: true,
      "aria-label": fieldLabel
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: isCopied ? copiedLabel : copyLabel,
      children: /*#__PURE__*/_jsx(StyledCopyButton, {
        "aria-label": isCopied ? copiedLabel : copyLabel,
        icon: isCopied ? /*#__PURE__*/_jsx(CheckOutlined, {}) : /*#__PURE__*/_jsx(CopyOutlined, {}),
        onClick: handleCopy
      })
    })]
  });
};

var ShareAssignmentContent = function ShareAssignmentContent(_ref3) {
  var sharedLink = _ref3.sharedLink,
      idNumber = _ref3.idNumber,
      absoluteShareUrl = _ref3.absoluteShareUrl,
      linkSectionLabel = _ref3.linkSectionLabel,
      qrCodeHint = _ref3.qrCodeHint,
      shareAssignmentTranslation = _ref3.shareAssignmentTranslation;
  var urlToCopy = absoluteShareUrl !== null && absoluteShareUrl !== void 0 ? absoluteShareUrl : sharedLink;
  var linkLabel = linkSectionLabel !== null && linkSectionLabel !== void 0 ? linkSectionLabel : shareAssignmentTranslation.shareAssignmentNow;
  return /*#__PURE__*/_jsxs(StyledShareContent, {
    children: [/*#__PURE__*/_jsxs(StyledSection, {
      children: [/*#__PURE__*/_jsx(StyledInformation, {
        children: linkLabel
      }), /*#__PURE__*/_jsx(CopyField, {
        text: urlToCopy,
        fieldLabel: linkLabel,
        copyLabel: shareAssignmentTranslation.copy,
        copiedLabel: shareAssignmentTranslation.copied
      })]
    }), absoluteShareUrl && /*#__PURE__*/_jsxs(StyledQrBlock, {
      children: [qrCodeHint ? /*#__PURE__*/_jsx(StyledQrHint, {
        children: qrCodeHint
      }) : null, /*#__PURE__*/_jsx(StyledQrImage, {
        src: "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=".concat(encodeURIComponent(absoluteShareUrl)),
        alt: qrCodeHint || linkLabel
      })]
    }), idNumber && /*#__PURE__*/_jsxs(StyledSection, {
      children: [/*#__PURE__*/_jsx(StyledInformation, {
        children: shareAssignmentTranslation.shareByAssignmentId
      }), /*#__PURE__*/_jsx(CopyField, {
        text: idNumber,
        fieldLabel: shareAssignmentTranslation.shareByAssignmentId,
        copyLabel: shareAssignmentTranslation.copy,
        copiedLabel: shareAssignmentTranslation.copied
      })]
    })]
  });
};

var ShareAssignmentModalContent = function ShareAssignmentModalContent(_ref4) {
  var title = _ref4.title,
      sharedLink = _ref4.sharedLink,
      idNumber = _ref4.idNumber,
      absoluteShareUrl = _ref4.absoluteShareUrl,
      linkSectionLabel = _ref4.linkSectionLabel,
      qrCodeHint = _ref4.qrCodeHint,
      confirmText = _ref4.confirmText,
      _ref4$successIconUrl = _ref4.successIconUrl,
      successIconUrl = _ref4$successIconUrl === void 0 ? '/images/icons/icon-check-circle.png' : _ref4$successIconUrl,
      shareAssignmentTranslation = _ref4.shareAssignmentTranslation,
      onConfirm = _ref4.onConfirm;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShareAssignmentModalStyles, {}), /*#__PURE__*/_jsxs(StyledModalContent, {
      children: [/*#__PURE__*/_jsxs(StyledHeader, {
        children: [/*#__PURE__*/_jsx(StyledSuccessIcon, {
          src: successIconUrl,
          size: 40
        }), /*#__PURE__*/_jsx(StyledTitle, {
          children: title
        })]
      }), /*#__PURE__*/_jsx(ShareAssignmentContent, {
        idNumber: idNumber,
        sharedLink: sharedLink,
        absoluteShareUrl: absoluteShareUrl,
        linkSectionLabel: linkSectionLabel,
        qrCodeHint: qrCodeHint,
        shareAssignmentTranslation: shareAssignmentTranslation
      }), /*#__PURE__*/_jsx(StyledFooter, {
        children: /*#__PURE__*/_jsx(StyledConfirmButton, {
          type: "primary",
          onClick: onConfirm,
          children: confirmText || shareAssignmentTranslation.close
        })
      })]
    })]
  });
};

export var showShareAssignmentModal = function showShareAssignmentModal(props) {
  var modal;

  var handleClose = function handleClose() {
    var _props$onClose;

    modal.destroy();
    (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
  };

  modal = Modal.info({
    centered: true,
    width: 416,
    className: 'share-assignment-modal',
    icon: null,
    content: /*#__PURE__*/_jsx(ShareAssignmentModalContent, _objectSpread(_objectSpread({}, props), {}, {
      onConfirm: handleClose
    })),
    maskClosable: true,
    onCancel: handleClose
  });
  return modal;
};